import { render, staticRenderFns } from "./overseaRecharge.vue?vue&type=template&id=16454e42&scoped=true&"
import script from "./overseaRecharge.vue?vue&type=script&lang=js&"
export * from "./overseaRecharge.vue?vue&type=script&lang=js&"
import style0 from "./overseaRecharge.vue?vue&type=style&index=0&id=16454e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16454e42",
  null
  
)

export default component.exports